import type { ChangeEvent } from 'react';
import type { Data } from '../types';

type UploadCardProps = {
  isUploading: boolean;
  uploadError: string | null;
  uploadResult: Data | null;
  uploadFooter: string;
  onFileSelected: (file: File) => void;
};

export default function UploadCard({
  isUploading,
  uploadError,
  uploadResult,
  uploadFooter,
  onFileSelected,
}: UploadCardProps) {
  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const input = event.currentTarget;
    const file = input.files?.[0];
    if (!file) return;

    onFileSelected(file);
    input.value = '';
  };

  return (
    <div className="rounded-[20px] border border-accent/35 bg-[linear-gradient(180deg,rgba(53,25,44,0.95),rgba(31,13,26,0.95))] p-5 shadow-[0_20px_40px_rgba(0,0,0,0.45)]">
      <div className="flex items-center justify-between gap-3">
        <div>
          <div className="text-[18px] font-bold">Upload your match</div>
          <div className="mt-1 text-[13px] text-muted">Drag a log file to begin analysis</div>
        </div>
      </div>
      <div className="mt-[18px] grid gap-4">
        <div className="grid gap-3">
          <input
            id="demo-upload"
            className="hidden"
            type="file"
            accept=".txt"
            onChange={handleFileChange}
            disabled={isUploading}
          />
          <label
            htmlFor="demo-upload"
            className="cursor-pointer rounded-2xl border-2 border-dashed border-accent/50 bg-[rgba(31,13,26,0.8)] p-[22px] text-center font-semibold"
          >
            <span>Drop a .txt file here</span>
            <span className="mt-1.5 block text-[12px] text-muted">or click to browse</span>
          </label>
          {uploadError && (
            <div className="rounded-xl border border-t/40 bg-t/10 px-3 py-2.5 text-[12px] text-t">
              {uploadError}
            </div>
          )}
        </div>
      </div>
      <div className="mt-4 text-[12px] text-muted">{uploadFooter}</div>
    </div>
  );
}
